import { Component } from '@angular/core';
import * as moment from 'moment';
import { AbstractSectionComponent } from '../../shared/components/abstract-section/abstract-section.component';
import { ClinicalNoteService } from '../../../../shared/services/common/clinical-note.service';
import { ActiveUserService } from '../../../../shared/services/common/active-user.service';
import { ReviewService } from '../../../../shared/services/common/review.service';
import { LoadingStateService } from '../../../../shared/services/common/loading-state.service';
import { validateFormField } from '../../../../shared/validators';
import { catchError, finalize, of, take } from 'rxjs';

@Component({
  selector: 'noteSection-main-complaint',
  templateUrl: './main-complaint-section.component.html',
  styleUrls: ['../../shared/components/abstract-section/abstract-section.component.scss', './main-complaint-section.component.scss']
})
export class MainComplaintSectionComponent extends AbstractSectionComponent {

  public sectionTitle: string = 'Main Complaint';

  public override async validate(): Promise<boolean> {
    validateFormField(this.note);
    return this.note.valid;
  }

  public override async save(): Promise<boolean | null> {

    if (this.note.value && this.note.value !== '') {
      this.data.notes = [...(this.data.notes || []), {
        author: this.activeUserService.user!,
        content: this.note.value,
      }];
    }

    return super.save();
  }

  public saveNotes(runSave: boolean) {
    if (runSave) {
      this.saveAll().subscribe();
    }
  }

}
